// extracted by mini-css-extract-plugin
export var team_list = "styles-module--team_list--2meGd";
export var team_list_friend = "styles-module--team_list_friend--3Vtwy";
export var jsAnimInit = "styles-module--jsAnimInit--3M6wK";